import styles from "../app-header-main/app-header-main.module.css";
import {NavLink} from "react-router-dom";
import {useEffect} from "react";

function HeaderText ({setIsMenuOpen}) {






    const onClose = () => {
        setIsMenuOpen(false)
    };

    return (
        
        <ul className={styles.box}>
            <button type={"button"} className={styles.closeBtn}>
                <div className={styles.close} onClick={onClose}></div>
            </button>
            <li>
                <NavLink to={'/'} className={styles.link}>
                    <button className={styles.buttonHeader} type={"submit"} >
                        <span className={styles.text} onClick={onClose}>Главная</span>
                    </button>
                </NavLink>
            </li>
            <li>
                <NavLink to={'/profile'} className={styles.link}>
                    <button className={styles.buttonHeader} type={"submit"} >
                        <span className={styles.text} onClick={onClose}>Профиль</span>
                    </button>
                </NavLink>
            </li>
            <li>
                <NavLink to={'/analytics-and-news'} className={styles.link}>
                    <button className={styles.buttonHeader} type={"submit"} >
                        <span className={styles.text} onClick={onClose}>Новости и аналитика</span>
                    </button>
                </NavLink>
            </li>
            {/*
            <li>
                <NavLink to={'/info'} className={styles.link}>
                    <button className={styles.buttonHeader} type={"submit"} >
                        <span className={styles.text} onClick={onClose}>Информационные страницы</span>
                    </button>
                </NavLink>
            </li>
            */}
            {/*
            <li>
                <NavLink to={'/products'} className={styles.link}>
                    <button className={styles.buttonHeader}>
                        <span className={styles.text} onClick={onClose}>Продукты</span>
                    </button>
                </NavLink>
            </li>
             */}
            <li>
                <NavLink to={'/education'} className={styles.link}>
                    <button className={styles.buttonHeader}>
                        <span className={styles.text} onClick={onClose}>Обучение</span>
                    </button>
                </NavLink>
            </li>
            <li>
                <NavLink to={'/tables'} className={styles.link}>
                    <button className={styles.buttonHeader}>
                        <span className={styles.text} onClick={onClose}>Портфели</span>
                    </button>
                </NavLink>
            </li>
            <li>
                <NavLink to={'/about-us'} className={styles.link}>
                    <button className={styles.buttonHeader}>
                        <span className={styles.text} onClick={onClose}>О нас</span>
                    </button>
                </NavLink>
            </li>
        </ul>

    )
}

export default HeaderText